import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BgFallbackDirective } from '@banyan/commons/directives/bg-img-fallback.directive';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';
import { GradientComponent } from '@banyan/modules/standalone/gradient/gradient.component';
import { TranslateModule } from '@ngx-translate/core';

export interface ProductCategory {
  title: string;
  url: string;
  image: string;
}

@Component({
  selector: 'app-home-product-categories',
  templateUrl: './home-product-categories.component.html',
  styleUrls: ['./home-product-categories.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    GradientComponent,
    BgFallbackDirective,
    ButtonComponent,
  ],
})
export class HomeProductCategoriesComponent {
  router = inject(Router);
  activeCard: string = '';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() image: string = '';
  @Input() productCategories: ProductCategory[] = [];

  activateCard(cardName: string): void {
    if (cardName !== this.activeCard) {
      this.activeCard = cardName;
    }
  }

  redirectLink(link: string): void {
    this.router.navigate([`${link}`]).then();
  }
}
